<div *ngIf="valid" class="text-green-500 text-sm italic">
  <i class="fas fa-check"></i> {{ validText }}
</div>
<div *ngIf="!valid" class="text-red-500 text-sm italic">
  <i class="fas fa-times"></i> {{ sameText ? validText : errorText }}
</div>
